import { Button, Input, useDebounceCallback } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import type {
  FilterConditionDTO,
  OffsetPageQueryDTO,
} from "@/shared/contracts/base";
import {
  findCondition,
  removeConditions,
  upsertCondition,
} from "@/shared/contracts/query-helpers";

export function PartnerPendingLockFilter() {
  const nav = useNavigate({ from: "/app/sell/partner/pending-lock" });
  const search = useSearch({
    from: "/app/sell/partner/pending-lock",
  }) as OffsetPageQueryDTO;
  const filters = (search.filters as FilterConditionDTO[] | undefined) ?? [];

  const partnerLabelFilter = findCondition(filters, "partnerLabel");

  const [searchValue, setSearchValue] = useState<string>(
    (partnerLabelFilter?.value as string) || "",
  );

  useEffect(
    () => setSearchValue((partnerLabelFilter?.value as string) || ""),
    [partnerLabelFilter?.value],
  );

  const debounced = useDebounceCallback((val: string) => {
    setSearchValue(val);
    let nextFilters: FilterConditionDTO[] | undefined = filters;
    if (val) {
      nextFilters = upsertCondition(filters, {
        field: "partnerLabel",
        op: "contains",
        value: val,
      });
    } else {
      nextFilters = removeConditions(filters, "partnerLabel");
    }
    nav({
      search: {
        ...search,
        offset: 0,
        filters: nextFilters?.length ? nextFilters : undefined,
      },
    });
  }, 400);

  const hasFilter = !!partnerLabelFilter?.value;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        value={searchValue}
        placeholder="ຄົ້ນຫາ partner..."
        className="h-9 max-w-xs"
        onChange={(e) => {
          setSearchValue(e.target.value);
          debounced(e.target.value);
        }}
      />
      {hasFilter ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => {
            setSearchValue("");
            nav({
              search: {
                ...search,
                offset: 0,
                filters: removeConditions(filters, "partnerLabel"),
              },
            });
          }}
        >
          <XIcon className="mr-1 size-4" />
          ລ້າງ
        </Button>
      ) : null}
    </div>
  );
}
